// extracted by mini-css-extract-plugin
export default {"video-wrapper":"_3fRKS","videoWrapper":"_3fRKS","preset-comment":"_1Fg8F","presetComment":"_1Fg8F","small-media":"Jpv_4","smallMedia":"Jpv_4","left":"fBHdg","right":"_2GtnN"};